import React from 'react'
import { Layout } from '../'
// TODO move ui
// import { Heading, Text } from '@brainstud/schiphol-vtc-ui'

const Instructions = props => (
  <Layout>
    <Heading h2>Instructions</Heading>

    <Text>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.</Text>
    <Text>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo.</Text>
    <Text>fringilla vel, aliquet nec, vulputate eget, arcu.</Text>
  </Layout>
)

export default Instructions
